import { render, staticRenderFns } from "./AddFriend.vue?vue&type=template&id=759f16cc&scoped=true&"
import script from "./AddFriend.vue?vue&type=script&lang=ts&"
export * from "./AddFriend.vue?vue&type=script&lang=ts&"
import style0 from "./AddFriend.vue?vue&type=style&index=0&id=759f16cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759f16cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
